import React from 'react';
import Button from '../../../components/ui/Button';
import BookingStatusBadge from './OrderStatusBadge';
import { Checkbox } from '../../../components/ui/Checkbox';

const OrderTableRow = ({
  booking,
  isSelected,
  onSelect,
  canSelect = true,
  onViewDetails,
  onContact
}) => {
  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });

  const itemsCount = booking?.items?.length || 0;

  const subtotal =
    booking?.items?.reduce(
      (sum, item) => sum + item.unitPrice * item.quantity,
      0
    ) ?? 0;

  const total = Number.isFinite(booking?.totalAmount)
  ? booking.totalAmount
  : subtotal;

  return (
    <tr className="border-b border-border hover:bg-muted/50 transition-colors">
      {/* Select */}
      {canSelect && (
        <td className="px-4 py-4">
          <Checkbox
            checked={isSelected}
            onChange={(e) => onSelect(booking.id, e.target.checked)}
          />
        </td>
      )}

      {/* Client */}
      <td className="px-4 py-4">
        <div className="flex flex-col">
          <span className="font-caption font-medium text-foreground">
            {booking.clientName}
          </span>
          <span className="text-sm text-muted-foreground font-caption">
            {booking.clientEmail}
          </span>
        </div>
      </td>

      {/* Phone */}
      <td className="px-4 py-4 whitespace-nowrap">
        {booking.clientPhone}
      </td>

      {/* Items */}
      <td className="px-4 py-4">
        <span className="text-sm font-caption text-foreground">
          {itemsCount} item{itemsCount !== 1 && 's'}
        </span>
      </td>

      {/* Total */}
      <td className="px-4 py-4 whitespace-nowrap">
        GH¢{total.toFixed(2)}
      </td>

      {/* Date */}
      <td className="px-4 py-4 whitespace-nowrap">
        {formatDate(booking.date)}
      </td>

      {/* Status */}
      <td className="px-4 py-4">
        <BookingStatusBadge status={booking.status} />
      </td>

      {/* Actions */}
      <td className="px-4 py-4">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="Eye"
            onClick={() => onViewDetails(booking)}
          >
            View
          </Button>

          <Button
            variant="ghost"
            size="sm"
            iconName="Phone"
            onClick={() => onContact(booking.clientPhone)}
          >
            Contact
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default OrderTableRow;
